<template>

  <div>
    <!-- Table Container Card -->
    <b-card no-body class="mb-0">
      <div class="loading_page" v-if="loading">
        <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'" />
      </div>
      <div class="m-2">

        <wash-plan-form :on-submit="onSubmit" :plan-data="planData" :errors="errors">
        </wash-plan-form>
      </div>
    </b-card>
  </div>
</template>

<script>

import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink, BFormInvalidFeedback,
  BBadge, BDropdown, BDropdownItem, BPagination, BForm, BFormGroup, BFormCheckboxGroup
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { OrbitSpinner } from 'epic-spinners'
import { computed, onUnmounted, ref, watch } from '@vue/composition-api'
import store from '@/store'

import { PlanStore } from "@/app/plans/wash/state";

import flatPickr from 'vue-flatpickr-component'
import Ripple from "vue-ripple-directive"
import WashPlanForm from '@/views/modules/plans/wash-plan/share/WashPlanForm'


export default {
  components: {
    OrbitSpinner, flatPickr, BFormInvalidFeedback,
    BCard, BRow, BCol, BFormInput, BButton, BTable, BFormCheckboxGroup,
    BMedia, BAvatar, BLink, BBadge, BDropdown, BDropdownItem, BPagination,
    vSelect, BForm, BFormGroup,
    WashPlanForm
  },
  directives: {
    Ripple,
  },

  setup(props, { root }) {


    // Register module
    if (!store.hasModule('plans'))
      store.registerModule('plans', PlanStore)


    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule('plans'))
        store.commit('plans/RESET_STORE_DATA')
      store.unregisterModule('plans')
    })





    const planData = computed(() => store.state.plans.data)
    const errors = computed(() => store.state.plans.errors)
    const loading = computed(() => store.state.plans.loading)


    const onSubmit = () => {

     
      
      store.dispatch('plans/createPlan').then(res => {
        planData.value.containers_excl_file=null
        root.$bvToast.toast(root.$t('network plan added successfully'), {
          title: root.$t("success"),
          variant: 'success',
          solid: false,
        })

      }).catch(reason => {
        console.log(reason)

        root.$bvToast.toast(root.$t(reason), {
          title: root.$t("Error"),
          variant: 'danger',
          solid: false,
        })
      })
    }


    return {

      onSubmit,
      loading,
      planData,
      errors,
    }

  }

}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.per-page-selector {
  width: 90px;
}

.actionIcon>button {
  padding: 0;
}
</style>
